// eslint-disable-next-line max-classes-per-file
import { LocalDateTime, LocalTime } from '@js-joda/core'
import { RealTimeMediaStatus } from '../../types/real-time-media-status'
import { RealTimeSecondaryContentType } from './playback.model'

export class RealTimeSecondaryContentShownEvent {
  static readonly type = '[Playback] SecondaryContent Shown event'

  constructor(public type: RealTimeSecondaryContentType) {}
}

export class RealTimeSecondaryContentHiddenEvent {
  static readonly type = '[Playback] SecondaryContent Hidden event'
}

export class RealTimePlaybackTimeJumpedEvent {
  static readonly type = '[Playback] Playback Time Jumped'

  constructor(
    readonly playbackTime: LocalDateTime,
    readonly status: RealTimeMediaStatus,
  ) {}
}

export class RealTimeHearingAnnotationTriggeredEvent {
  static readonly type = '[Playback] Hearing Annotation Triggered'

  constructor(readonly hearingStartTime: LocalTime) {}
}
